export const DimensionUnit = Object.freeze({
  Unknown: 'Unknown',
  Inches: 'Inches',
  Centimeters: 'Centimeters',
  Inch: 'Inch',
  Centimeter: 'Centimeter',
});
